import { HIDE_LOADER, SHOW_LOADER } from '../Actions/Loader.action';

const defaultState = {
    isEnabled: true,
    isVisible: false,
    thresholdInMilliseconds: 0,
};

export const loader = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case HIDE_LOADER:
            return {
                ...state,
                isVisible: false,
            };
        case SHOW_LOADER:
            return {
                ...state,
                text: payload.text,
                isVisible: true,
            };
        default:
            return {
                ...state,
                isVisible: false,
            };
    }
};
